module.exports = __webpack_public_path__ + "d785d15a393fabd8a637457a4ececc19.svg";